import {map, filter} from "lodash"
import flat from "flat"
import supported from "./supported.json"

export default () => {
  return filter(
    map(flat(supported), (label, key) => {
      const value = key.split(".").pop()
      if (value === "default") {
        return
      }
      return {value, label}
    }),
    (test) => !!test
  )
}
